import { computed } from "vue"
import { mapState } from "vuex"

export default function useSortCount() {
  const filters = mapState("filter", {
    sort: ({ filters }) => filters.sort,
  })

  const sort = computed(filters.sort)

  const isActive = computed(() => sort.value !== "relevant")

  return computed(() => ({
    badgeContent: isActive.value ? 1 : 0,
    badgeCondition: isActive.value,
  }))
}
